import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import RichText from '@/components/RichText';

/* =====================================================================
   FaqAccordion — soru/cevap listesi (faqs: [{ q, a }]).
   Cevaplar kapalıyken de DOM'da kalır (forceMount) → prerender HTML'inde ve FAQPage
   şemasıyla birebir aynı metin bulunur. forceMount'ta Radix gizlemediği için kapalı
   bölge (role=region) item üzerindeki CSS ile gizlenir.
   ===================================================================== */

const FaqAccordion = ({ faqs }) => (
  <Accordion type="multiple" className="space-y-3">
    {faqs.map((faq) => (
      <AccordionItem
        key={faq.q}
        value={faq.q}
        className="rounded-2xl border border-hairline bg-surface px-5 transition-colors hover:border-brand-200 data-[state=open]:border-brand-200 [&>[role=region][data-state=closed]]:hidden"
      >
        <AccordionTrigger className="gap-4 py-4 text-left font-poppins text-base font-semibold text-ink-strong hover:no-underline">
          {faq.q}
        </AccordionTrigger>
        <AccordionContent forceMount className="font-inter text-[15px] leading-relaxed text-ink-muted">
          <RichText text={faq.a} />
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export default FaqAccordion;
